module.exports = __webpack_public_path__ + "static/media/cocktails.d99fe442.png";